import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const athenaClubBomExportLineSchema = yup
  .object({
    materialSku: yup.string().nullable().optional(),
    materialName: yup.string().nullable().optional(),
    uom: yup.string().nullable().optional(),
    quantity: yup.string().nullable().optional(),
    supplier: yup.string().nullable().optional(),
    notes: yup.string().nullable().optional(),
    notOrderedByAc: yup.string().nullable().optional(),
  })
  .required()

export const athenaClubBomExportXlsxFileDataSchema = yup
  .object({
    brand: yup.string().nullable().optional(),
    productName: yup.string().nullable().optional(),
    variant: yup.string().nullable().optional(),
    region: yup.string().nullable().optional(),
    internalFgCode: yup.string().nullable().optional(),
    upc: yup.string().nullable().optional(),
    innerCount: yup.string().nullable().optional(),
    masterCaseCount: yup.string().nullable().optional(),
    fillClaim: yup.string().nullable().optional(),
    sku: yup.string().nullable().optional(),
    bomName: yup.string().nullable().optional(),
    bomVersion: yup.string().nullable().optional(),
    coManufacturer: yup.string().nullable().optional(),
    effectiveDate: yup.string().nullable().optional(),
    dateToday: yup.string().nullable().optional(),
    bomLines: yup.array().of(athenaClubBomExportLineSchema).required(),
  })
  .required()

export type AthenaClubBomExportXlsxFileData = yup.InferType<
  typeof athenaClubBomExportXlsxFileDataSchema
>
export type AthenaClubBomExportLineData = yup.InferType<typeof athenaClubBomExportLineSchema>

type RequiredFileData = MakeRequiredAndNullable<AthenaClubBomExportXlsxFileData>

const bomLineMappings: MakeRequiredAndNullable<AthenaClubBomExportLineData> = {
  materialSku: '5de92bf6-18e6-474b-b2e5-85c28500adbe',
  materialName: '23f2bf3b-14d9-4098-a94f-3f22a6b701db',
  uom: '5cd403fd-aba3-4fee-8870-1b372ec85e22',
  quantity: '6033004b-6247-4c2e-a3e3-8ac133141ac6',
  supplier: '01a1c812-fc7d-4c1d-b3fb-966b063f1805',
  notes: 'c85234c5-2faa-433a-929c-8af135381d98',
  notOrderedByAc: '7a528e1b-7c06-4908-8e38-e336ebbc18a0',
}

export const athenaClubBomExportXlsxFileMappings: RequiredFileData = {
  brand: '9173caef-ea5b-4070-baec-d584eb291a3e',
  productName: '2b3aff2f-ddbe-4d79-ab4e-ccc24dcda2fa',
  variant: '9109c49a-2fe8-45bd-941f-06d18976e20b',
  region: 'fd3d4561-ef38-477e-a415-91a177ece22b',
  internalFgCode: '6d564428-f690-4d5f-8691-7dee4d3b06e5',
  upc: '99f32534-7cae-424d-be4a-071ae08254eb',
  innerCount: '3c1c218b-3049-4b83-87fc-b1167a0070fe',
  masterCaseCount: '99727bca-7cdf-40e9-9ec0-285d3b1c9278',
  fillClaim: 'aea35692-5861-4da0-add7-ad5c04567197',
  sku: 'e10c6a9e-0c2d-4973-986a-12a87dbf8f41',
  bomName: '6156318a-a5a1-4dac-a3c6-c5ef49fe90df',
  bomVersion: 'a185e24a-17a9-427d-bf48-e2b7301d8e5d',
  coManufacturer: 'b2a4db8d-8f63-4b06-a2e9-6c9cd15dff8e',
  effectiveDate: '1cb08bc0-16e7-474b-b6ee-c5012da17c2e',
  dateToday: '58000df7-969b-4fce-b721-a9180136a973',
  bomLines: [bomLineMappings],
}
